import axios from 'axios';
import provedor from "../http/provedor.js";
import { API_URL } from './base-urls';
import { removerMascara, formatarCarteirinha } from '../utils/formatadores';

export async function obterCarteirinhaUGF(carteirinha) {
  try {

    carteirinha = removerMascara(carteirinha);    

    await provedor.dispatch("autenticar");
    const token = provedor.state.token;

    const config = {
      method: "get",
      url: `${API_URL}Caasc/CarteirinhaUGF/${carteirinha}`,
      headers: { Authorization: `Bearer ${token}` },
    };

    const response = await axios(config);    

    return formatarCarteirinha(response.data);

  } catch (error) {
    if (error.response && error.response.status === 404) {      
      return null;
    } else {
      throw error;
    }
  }
}

export async function validarCarteirinhaUGF(carteirinha) {
  try {
    carteirinha = removerMascara(carteirinha);

    await provedor.dispatch("autenticar");
    const token = provedor.state.token;

    const config = {
      method: "get",
      url: `${API_URL}Carteirinha/Validar?carteirinha=${carteirinha}`,
      headers: { Authorization: `Bearer ${token}` },
    };

    const response = await axios(config);
  
    if (response.status === 200) {
      return true;
    }

    throw new Error(`Erro inesperado: Status ${response.status}`);

  } catch (error) {
    if (error.response && (error.response.status === 404 || error.response.status === 400)) {
      return false;
    } else {
      console.error("Erro no serviço de validação:", error);
      throw error;
    }
  }
}